'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

exports.isObject = isObject;
exports.deepMerge = deepMerge;
exports.classNames = classNames;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isObject(item) {
  return item && (typeof item === 'undefined' ? 'undefined' : (0, _typeof3.default)(item)) === 'object' && !Array.isArray(item);
}

function deepMerge(target) {
  for (var _len = arguments.length, sources = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sources[_key - 1] = arguments[_key];
  }

  if (!sources.length) return target;
  var source = sources.shift();

  if (isObject(target) && isObject(source)) {
    (0, _keys2.default)(source).forEach(function (key) {
      if (isObject(source[key])) {
        if (!target[key]) (0, _assign2.default)(target, (0, _defineProperty3.default)({}, key, {}));
        deepMerge(target[key], source[key]);
      } else {
        (0, _assign2.default)(target, (0, _defineProperty3.default)({}, key, source[key]));
      }
    });
  }

  return deepMerge.apply(undefined, [target].concat(sources));
}

// Taken from https://www.npmjs.com/package/classnames
function classNames() {
  var _arguments = arguments;

  var classes = [];

  var _loop = function _loop(i) {
    var arg = _arguments.length <= i ? undefined : _arguments[i];

    if (arg) {
      var argType = typeof arg === 'undefined' ? 'undefined' : (0, _typeof3.default)(arg);

      if (argType === 'string' || argType === 'number') {
        classes.push(arg);
      } else if (Array.isArray(arg) && arg.length) {
        var inner = classNames.apply(undefined, (0, _toConsumableArray3.default)(arg));
        if (inner) {
          classes.push(inner);
        }
      } else if (argType === 'object') {
        (0, _keys2.default)(arg).forEach(function (key) {
          if ({}.hasOwnProperty.call(arg, key) && arg[key]) {
            classes.push(key);
          }
        });
      }
    }
  };

  for (var i = 0; i < arguments.length; i += 1) {
    _loop(i);
  }

  return classes.join(' ');
}


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/helpers/utils.js
// module id = 149
// module chunks = 0